import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { guageMockJson } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Guage = (props) => {


  const getOption = () => {
    let { graphprops } = props;

    let stringRange = graphprops.guage && graphprops.guage.range ? graphprops.guage.range : '[]';
    let uom = graphprops.guage && graphprops.guage.uom ? graphprops.guage.uom : '';

    let range = JSON.parse(stringRange);
    let min = range[0] || '';
    let max = range[1] || '';

    let colorArray = [];
    let colors = graphprops && graphprops.guage && graphprops.guage.colors ? graphprops.guage.colors : [];
    if (colors && Array.isArray(colors) && colors.length > 0) {
      let colorLength = colors.length;
      let staticValue = 100 / colorLength;
      let incrementValue = 0;
      colorArray = colors.map((colorData) => {
        incrementValue = staticValue + incrementValue;
        return [incrementValue / 100, colorData];
      });
    }

    return {
      tooltip: {
        formatter: '{c}'
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'download',
            backgroundColor: props.theme.algorithm === "dark" ? 'black' : 'white',
            name: graphprops && graphprops.title ? graphprops.title : '',
            iconStyle: {
              color: 'none',
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          name: uom,
          title: {
            offsetCenter: [0, '30%'],
            fontSize: 15,
            fontStyle: 'italic',
            color: graphprops && graphprops.guage && graphprops.guage.titleColor ? graphprops.guage.titleColor : ''
          },
          type: 'gauge',
          axisLabel: {
            color: 'auto',
            distance: 20,
            fontSize: 14
          },
          axisTick: {
            show: true
          },
          splitLine: {
            length: 15,
            lineStyle: {
              width: 5,
              color: 'auto'
            }
          },
          axisLine: {
            lineStyle: {
              color: graphprops && graphprops.guage && graphprops.guage.guageType === 'normalGuage'
                ? colorArray.length > 0 ? colorArray : [[0.2, '#e34b04'], [0.8, '#fec91b'], [1, '#6daa11']]
                : [[0.2, '#e34b04'], [0.8, '#fec91b'], [1, '#6daa11']],
              show: true,
              width: 18
            }
          },
          pointer: {
            itemStyle: {
              color: 'auto'
            }
          },
          detail: {
            formatter: `{value} ${uom}`,
            fontSize: 25,
            color: graphprops && graphprops.guage && graphprops.guage.titleColor ? graphprops.guage.titleColor[0] : 'auto',
            valueAnimation: true,
            offsetCenter: [0, '80%']
          },
          splitNumber: graphprops && graphprops.guage && graphprops.guage.SplitNumber ? Number(graphprops.guage.SplitNumber) : 10,
          min: min,
          max: max,
          data: [
            {
              name: '',
              value: 0
            }
          ]
        }
      ]
    };
  };

  const [option, setOption] = useState(getOption());
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = async () => {
    requestCheck.current = false;
    let guageType = graphprops && graphprops.guageType;
    let errorInAPI = false;
    let noDataInDB = false;
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = guageMockJson;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      const newOption = cloneDeep(option);

      if (json && Array.isArray(json) && json.length > 0) {
        let tagValue = Number(json[0].Value).toFixed(2);
        let progress = {};
        let anchor = {
          show: true,
          showAbove: true,
          size: 25,
          itemStyle: {
            borderWidth: 10
          }
        };
        if (guageType && guageType === 'speedGuage') {
          progress = {
            show: true,
            width: 18
          };
          newOption.series[0].progress = progress;
          newOption.series[0].anchor = anchor;
        }

        newOption.series[0].data[0].value = tagValue;
      }

      setOption(newOption);
      setRefreshDateTime(moment());
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          id={Math.ceil(Math.random(100, 100000) * 1000)}
          option={option}
          style={{
            height: '90%',
            width: '100%'
          }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(Guage);